import { Component, Input, OnInit, Output , EventEmitter} from '@angular/core';

@Component({
  selector: 'app-accept-privacy-policy-and-terms',
  templateUrl: './accept-privacy-policy-and-terms.component.html',
  styleUrls: ['./accept-privacy-policy-and-terms.component.scss'],
})
export class AcceptPrivacyPolicyAndTermsComponent implements OnInit {

  @Input() privacyPolicyAcceptedDate = false;

  @Output() privacyPolicyAcceptedDateChange = new EventEmitter();

  @Input() checkBoxSize = '30px'

   @Input() checkboxHidden = false;

  constructor() { }

  ngOnInit(): void {

  }

  onChangeCheckbox(){
    console.log('this.privacyPolicyAcceptedDate=====',this.privacyPolicyAcceptedDate);
    this.privacyPolicyAcceptedDateChange.emit(this.privacyPolicyAcceptedDate)
  }

}
